module.exports = __webpack_public_path__ + "media/src/images/professor_bg-2ec0e38df7f2046e834e6d9f891279f1.jpg";